import React from 'react'
import Chrome from '#src/components/Chrome'
import { FullBlockLoader, CircleLoader } from '@deal/components'

interface RouteLoaderProps {}

const RouteLoader: React.SFC<RouteLoaderProps> = () => {
  return (
    <Chrome>
      <FullBlockLoader loader={CircleLoader} />
    </Chrome>
  )
}

export default RouteLoader
